import React, { Component } from 'react';
import Slider from 'react-slick';

const CrackedCodeSettings = {
  dots: true,
  arrows: true,
  infinite: true,
  speed: 500,
  slidesToShow: 2.5,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 5000,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 1,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        dots: true,
        arrows: true,
      },
    },
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 1,
        dots: true,
        arrows: true,
      },
    },
  ],
};

class OnlineStudentSlider extends Component {
  render() {
    const sliderItems = [
      { id: 1, name: " - Anisha P.", location: "Now studying in Vancouver", description: "After struggling with confidence and failing my first test, this program gave me the skills I needed to score CLB 8. I'm so happy to say I got my study visa!" },
      { id: 2, name: "- Arjun T.", location: "Now a resident in Calgary", description: "Language Academy gave me the personalized support I needed. I achieved the scores required for PR after three weeks of focused coaching." },
      { id: 3, name: " - Anisha P.", location: "Now studying in Vancouver", description: "After struggling with confidence and failing my first test, this program gave me the skills I needed to score CLB 8. I'm so happy to say I got my study visa!" },
    ];

    return (
      <div className="cracked-section slider-dot-arrow">
        <div className="container">
          <h2
            className="primary-heading text-center"
            dangerouslySetInnerHTML={{ __html: this.props.title }}
          />
          <h3
            className="sub-title text-center fw-600 my-4"
             dangerouslySetInnerHTML={{ __html: this.props.subtitle }}
          />
        </div>
        <div className="slider-bleed-wrapper">
          <Slider {...CrackedCodeSettings} className="home-cards-slider">
            {sliderItems.map(item => (
              <div key={item.id}>
                <div className="crack-card">
                  <div className="crack-img-wrapper">
                    {/* Optional image or icon */}
                  </div>
                  <div className="crack-content">
                    <div className="user-info">
                      <div className="user-img">
                        <img src="/images/web-new-images/crack-user.png" alt={item.name} />
                      </div>
                      <div className="user-content">
                        <h3 className="user-name">{item.name}</h3>
                        <h3 className="user-location">{item.location}</h3>
                      </div>
                    </div>
                    <div className="user-discription">
                      {item.description}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    );
  }
}

export default OnlineStudentSlider;
